export default "__VITE_ASSET__36i4aHOU__"